<template>
  <div>
    <download-excel
      v-if="isEnabled"
      :data="data"
      type="xls"
      :name="`${fileName}.xls`"
    >
      <b-button
        variant="outline-primary"
        class="flex-shrink-0 w-100"
      >
        Download Data
        <i class="bx bx-download ms-2" />
      </b-button>
    </download-excel>
    <div v-else>
      <span id="download-data-disabled">
        <b-button
          variant="outline-primary disabled"
          class="flex-shrink-0 w-100"
          style="pointer-events: none;"
          disabled
        >
          Download Data
          <i class="bx bx-download ms-2" />
        </b-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    fileName: {
      type: String,
      default: 'data',
    },
    isEnabled: {
      type: Boolean,
      default: true,
    },
    fields: {
      type: Array,
      default() {
        return {};
      },
    },
  },
};
</script>
